const replaceSlush = async (target) => {
    return target.replace(/\\/g, "/")
}


const replaceHyphen = async (target) => {
    return target.replace(/-/g, "/")
}

const deleteSpace = async (target) => {
    return target.replace(/\s/g, "");
}

export default {
    replaceSlush,
    replaceHyphen,
    deleteSpace,
}
